import { isRecord } from "@shared/validation/is-record";
import type { RequestGeo } from "@/lib/request-context";

function toRequestGeo(payload: unknown): RequestGeo | null {
  if (!isRecord(payload)) return null;
  const { city, state, latitude, longitude, postalCode } = payload;
  if (typeof city !== "string" || typeof state !== "string") return null;
  if (typeof latitude !== "number" || !Number.isFinite(latitude)) return null;
  if (typeof longitude !== "number" || !Number.isFinite(longitude)) return null;
  return {
    city,
    state,
    latitude,
    longitude,
    postalCode: typeof postalCode === "string" ? postalCode : "",
  };
}

export async function fetchRequestGeo(signal?: AbortSignal): Promise<RequestGeo | null> {
  try {
    const response = await fetch("/api/request-geo", { cache: "no-store", signal });
    if (!response.ok) return null;
    return toRequestGeo(await response.json());
  } catch {
    return null;
  }
}
